import * as actions from './actions';
import { createReducer } from '@reduxjs/toolkit';
import { createSupportedEventTypeOptions } from './helpers';
import set from 'lodash.set';

const initialState = {
  supportedEventTypes: {
    error: null,
    data: null,
    options: null,
    productIntegrationOptions: null,
    integratingProducts: null,
    productCategories: null,
    productNames: null
  },
  gettingProductNames: true,
  supportedScheduledTypes: [],
  supportedOnDemandTypes: [],
  supportedInternalSurveyResponseTypes: [],
  supportedExternalSurveyResponseTypes: [],
  eventMetaData: {
    error: {},
    data: {}
  },
  recipientTemplates: {
    error: null,
    data: null
  }
};

export default createReducer(initialState, {
  // get supported event types
  [actions.GET_SUPPORTED_EVENT_TYPES]: state => state,
  [actions.GETTING_SUPPORTED_EVENT_TYPES]: state => {
    return state;
  },
  [actions.GETTING_SUPPORTED_EVENT_TYPES_SUCCEEDED]: (state, action) => {
    const {
      payload: { supportedEventTypes = [], mergedMetaData }
    } = action;

    const {
      eventOptions,
      productIntegrationOptions,
      printOptions,
      scheduledOptions,
      onDemandOptions,
      internalSurveyResponseOptions,
      externalSurveyResponseOptions,
      integratingProducts,
      availableIntegrations,
      allEventTypeCategoryOptions,
      transientProductCategories,
      transientProductNames,
      externalTransientProductCategories,
      externalTransientProductNames,
      allEventOptions,
      externalProductCategories,
      externalProductNames
    } = createSupportedEventTypeOptions(supportedEventTypes, mergedMetaData);

    let { productCategories, productNames } = availableIntegrations;
    state.supportedEventTypes.integratingProducts = integratingProducts;
    state.supportedEventTypes.data = supportedEventTypes;
    state.supportedScheduledTypes = scheduledOptions;
    state.supportedOnDemandTypes = onDemandOptions;
    state.supportedInternalSurveyResponseTypes = internalSurveyResponseOptions;
    state.supportedExternalSurveyResponseTypes = externalSurveyResponseOptions;
    state.supportedPrintTypes = printOptions;
    state.supportedEventTypes.options = eventOptions;
    state.supportedEventTypes.productIntegrationOptions =
      productIntegrationOptions || [];
    state.supportedEventTypes.allEventTypeCategoryOptions =
      allEventTypeCategoryOptions || [];
    state.supportedEventTypes.allEventOptions = allEventOptions || [];
    state.supportedEventTypes.productCategories = productCategories;
    state.supportedEventTypes.productNames = productNames;
    state.supportedEventTypes.transientProductCategories = transientProductCategories;
    state.supportedEventTypes.transientProductNames = transientProductNames;
    state.supportedEventTypes.externalTransientProductCategories = externalTransientProductCategories;
    state.supportedEventTypes.externalTransientProductNames = externalTransientProductNames;
    state.supportedEventTypes.externalProductCategories = externalProductCategories;
    state.supportedEventTypes.externalProductNames = externalProductNames;
    state.gettingProductNames = false;
    return state;
  },
  [actions.GETTING_SUPPORTED_EVENT_TYPES_FAILED]: (state, action) => {
    state.supportedEventTypes.error = action.error;
    state.gettingProductNames = false;
    return state;
  },
  // get event meta data
  [actions.GET_EVENT_META_DATA]: state => state,
  [actions.GETTING_EVENT_META_DATA]: state => state,
  [actions.GETTING_EVENT_META_DATA_SUCCEEDED]: (state, action) => {
    state.eventMetaData.data = action.payload.eventMetaData;
    return state;
  },
  [actions.GETTING_EVENT_META_DATA_FAILED]: state => state
});
